import { getTabsConfig } from "./tabsConfig";

export const GetTabs = () => {
  const path = window.location.pathname.split('/')[1];
  const configsTabs = getTabsConfig();

  return configsTabs[path as keyof typeof configsTabs];
};
